module.exports = __webpack_public_path__ + "img/ren.c7bc0d99.png";